import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-video-inicial',
  templateUrl: './video-inicial.component.html',
  styleUrls: ['./video-inicial.component.css']
})
export class VideoInicialComponent implements OnInit {

  showModal = true;
  loading = false;
  checkMarcado = false;
  onSaveCambios = new Subject<any>();

  constructor(
    private _bsModalRef: BsModalRef,
    private toastr: ToastrService,
  ) { }

  public ngOnInit() {
    this.onSaveCambios = new Subject();
  }

  showConfirmationModal(checkMarcado) {
    this.checkMarcado = checkMarcado;
  }

  public onCancel(): void {
    this.showModal = false;
    this.onSaveCambios.next(this.checkMarcado);
    this._bsModalRef.hide();
  }

  onChange(values: any) {
    this.checkMarcado = values.currentTarget.checked;
  }

}
